import get from 'lodash/get';
import find from 'lodash/find';

/* eslint-disable no-plusplus */
const ranges = [
  { divider: 1e9, suffix: 'Bn', abbr: 'BLN' },
  { divider: 1e6, suffix: 'MM', abbr: 'MLN' },
  { divider: 1e3, suffix: 'k', abbr: 'K' },
];

export function getRange(data: any, fields: string[]) {
  const rangesCount = [0, 0, 0];

  data.forEach((item: any) => {
    let v = 0;
    fields.forEach((field: string) => {
      v += get(item, field, 0);
    });
    if (item.y >= ranges[0].divider) {
      rangesCount[0]++;
    } else if (v >= ranges[1].divider) {
      rangesCount[1]++;
    } else if (v >= ranges[2].divider) {
      rangesCount[2]++;
    }
  });

  if (rangesCount[0] >= rangesCount[1] && rangesCount[1] > rangesCount[2])
    return {
      index: 0,
      abbr: ranges[0].abbr,
    };
  if (rangesCount[1] >= rangesCount[2])
    return {
      index: 1,
      abbr: ranges[1].abbr,
    };
  return {
    index: 2,
    abbr: ranges[2].abbr,
  };
}

export function getMoneyValueWithMetricPrefix(
  n: number,
  rangeIndex: number
): string {
  const hasDecimal = n - Math.floor(n) !== 0;

  const round = (num: number, decimals: number) => {
    // @ts-ignore
    return Number(`${Math.round(`${num}e${decimals}`)}e-${decimals}`);
  };
  if (hasDecimal) {
    const divided = n / ranges[rangeIndex].divider;
    return round(divided, 2).toString();
  }
  if (rangeIndex) {
    return (n / ranges[rangeIndex].divider).toString();
  }
  const fRange = find(ranges, (r) => n >= r.divider);
  if (fRange) {
    return (n / fRange.divider).toString();
  }
  return n.toString();
}
